import { useEffect } from "react";
import usePrevious from "hooks/usePrevious";
import { useLatest } from "hooks/useLatest";
import { createPrimitiveDepsKey } from "utils/createPrimitiveDepsKey";
import { UseResetPaginationOnDepsChangeArgs } from "./types";

export const useResetPaginationOnDepsChange = ({
  resetDeps,
  page,
  limit,
  setPage,
  run,
}: UseResetPaginationOnDepsChangeArgs) => {
  const resetKey = createPrimitiveDepsKey(resetDeps);
  const previousResetKey = usePrevious(resetKey);

  const argumentsRef = useLatest({ page, limit, run, setPage });

  useEffect(() => {
    if (previousResetKey === undefined) return;

    if (previousResetKey === resetKey) return;

    const { page, limit, run, setPage } = argumentsRef.current;

    if (page !== 1) {
      setPage(1);
      return;
    }

    run({ page: 1, limit });
  }, [resetKey, previousResetKey, argumentsRef]);
};
